import React from 'react';
import FadeIn from './FadeIn';
import Button from './Button';

export default function Benefits() {
  const handlePurchase = () => {
    window.location.href = 'https://coassemble.com/learn/IXKIQH';
  };

  return (
    <section className="py-24 bg-slate-50 px-4 sm:px-6 overflow-hidden">
      <div className="max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <FadeIn>
            <h2 className="text-3xl sm:text-4xl font-bold text-slate-900 mb-8 leading-tight">
              Imagine life 7 days from now.
            </h2>
            <p className="text-xl text-slate-700 leading-relaxed mb-8">
              You wake up on payday. You don't feel a sense of dread. You open your banking app and you know exactly what every dollar is supposed to do. You have a plan for the bills that are behind, and you know the lights will stay on.
            </p>
            <div className="space-y-4 mb-10">
              <p className="text-2xl font-semibold text-slate-900">
                The panic is gone. <br />
                <span className="text-blue-600">You are in control.</span>
              </p>
            </div>
            <div className="flex justify-start">
              <Button onClick={handlePurchase}>Start My 7-Day Reset</Button>
            </div>
          </FadeIn>
          
          <FadeIn delay={0.2} className="relative">
            <div className="relative z-10 rounded-3xl overflow-hidden shadow-2xl">
              <img 
                src="https://images.unsplash.com/photo-1512486130939-2c4f79935e4f?auto=format&fit=crop&q=80&w=1000" 
                alt="Relieved person with coffee" 
                className="w-full aspect-[4/5] object-cover"
              />
            </div>
            <div className="absolute -top-12 -right-12 w-64 h-64 bg-blue-100 rounded-full mix-blend-multiply filter blur-3xl opacity-70"></div>
            <div className="absolute -bottom-12 -left-12 w-64 h-64 bg-emerald-100 rounded-full mix-blend-multiply filter blur-3xl opacity-70"></div>
          </FadeIn>
        </div>
      </div>
    </section>
  );
}